import { Tooltip } from "antd";
import { toJS } from "mobx";
import { observer } from "mobx-react";
import { isValidElement, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { dashboardStores } from "../../pages/Dashboard/DashboardStores";
import FilterBar from "../FilterBar";

const TOPNAV_OFFSET = 52;

const getButtonLabel = (node) => {
  if (node === null || node === undefined || typeof node === "boolean") return "";
  if (typeof node === "string" || typeof node === "number") return String(node);
  if (Array.isArray(node)) return node.map(getButtonLabel).join("");
  if (isValidElement(node)) return getButtonLabel(node.props?.children);
  return "";
};

const Header = observer(() => {
  const title = dashboardStores.title;
  const titleButtons = toJS(dashboardStores.titleButtons);
  const filterBlocks = toJS(dashboardStores.filterBlocks);
  const [affixed, setAffixed] = useState(false);
  const history = useHistory();
  const sentinelRef = useRef(null);

  useEffect(() => {
    if (history?.location?.pathname) setAffixed(false);
  }, [history?.location?.pathname]);

  useEffect(() => {
    const el = sentinelRef.current;
    if (!el) {
      setAffixed(false);
      return undefined;
    }
    const observer = new IntersectionObserver(([entry]) => setAffixed(!entry.isIntersecting), {
      rootMargin: `-${TOPNAV_OFFSET}px 0px 0px 0px`,
      threshold: 0,
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [title]);

  return title ? (
    <>
      <div className={`header bg-gradient-primary mt-[-1px] ${filterBlocks.length ? "!pb-2" : "!pb-12"}`}>
        <div className={`container-fluid ${filterBlocks?.length ? "" : "!pb-3"}`}>
          <div className="header-body">
            <div className="row items-center">
              <div className="mx-[15px] truncate">
                <h6 className="h2 text-white d-inline-block mb-0">{title}</h6>
              </div>
              {!!titleButtons?.length && (
                <div className="flex-1 mr-[15px] text-right">
                  {titleButtons.map((item, index) => (
                    <span key={`title-button-${index}`} className="!ml-2">
                      {item}
                    </span>
                  ))}
                </div>
              )}
            </div>
            <div ref={sentinelRef} aria-hidden className="h-0" />
          </div>
        </div>
      </div>
      {!!filterBlocks?.length && (
        <div className="!sticky top-[52px] z-[100] container-fluid flex justify-between items-center bg-gradient-primary !pb-3">
          <div className="flex-1 min-w-0">
            <FilterBar items={filterBlocks} />
          </div>
          {!!titleButtons?.length && (
            <div className={`flex shrink-0 !ml-2 ${affixed ? "visible" : "invisible"}`}>
              {titleButtons.map((item, index) => {
                const label = getButtonLabel(item).trim();
                return (
                  <Tooltip key={`title-button-${index}`} title={label} placement="bottom">
                    <span className="!ml-2 group hidden-text">{item}</span>
                  </Tooltip>
                );
              })}
            </div>
          )}
        </div>
      )}
    </>
  ) : null;
});

export default Header;
